import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * Thin wrapper over the shadcn Dialog with the Owner Console dark theme.
 * `open`, `onOpenChange`, `title`, `description`, `footer`, `children`.
 */
export default function ModalDS({
  open, onOpenChange, title, description, footer, children,
  testId, maxWidth = 520,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="hbf-modal"
        style={{ maxWidth }}
        data-testid={testId || "modal"}
      >
        {(title || description) && (
          <DialogHeader>
            {title && <DialogTitle className="hbf-modal__title">{title}</DialogTitle>}
            {description && <DialogDescription className="hbf-modal__desc">{description}</DialogDescription>}
          </DialogHeader>
        )}
        <div className="hbf-modal__body">{children}</div>
        {footer && <DialogFooter className="hbf-modal__footer">{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}
